// `@lingui/react` pulls in `use-sync-external-store/shim`, which breaks the client bundle, so
// we alias it here to React 19's native hook instead. See lib/vite/config.ts for the alias.
export { useSyncExternalStore } from 'react';
